import ValidationType from '../ValidationType';
import { isNumeric } from "../../util";

class NumericValue extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      // Only validate when field is not empty
      const current = fieldResponse.currentValue;
      const compare = validation.value;
      if (!isNumeric(current)) {
        errors.push(this.createValidationError({
          fieldResponse: fieldResponse,
          key: 'ERROR_INVALID_NUMERIC',
          values: { value: validation.value },
          message: `This field only accepts numeric values`,
        }));
      }
    }
    return errors;
  }
}

export default NumericValue;
